$(document).ready(function() {
    const rangeInput = $(document).find(".range-input input"),
        priceInput = $(document).find(".price-input input"),
        range = $(document).find(".slider .progress");
    let priceGap = 10;

    // Price input změny
    priceInput.each(function() {
        $(this).on("input", function(e) {
            let minPrice = parseInt(priceInput.eq(0).val()),
                maxPrice = parseInt(priceInput.eq(1).val());

            if ((maxPrice - minPrice >= priceGap) && maxPrice <= rangeInput.eq(1).attr("max")) {
                if ($(e.target).hasClass("input-min")) {
                    rangeInput.eq(0).val(minPrice);
                    range.css("left", ((minPrice / rangeInput.eq(0).attr("max")) * 100) + "%");
                } else {
                    rangeInput.eq(1).val(maxPrice);
                    range.css("right", 100 - (maxPrice / rangeInput.eq(1).attr("max")) * 100 + "%");
                }
            }
        });
    });
    let lastMin = null;
    let lastMax = null;
    // Range input změny
    rangeInput.each(function() {
        $(this).on("input", function(e) {
            let minVal = parseInt(rangeInput.eq(0).val()),
                maxVal = parseInt(rangeInput.eq(1).val());

            if ((maxVal - minVal) < priceGap) {
                if ($(e.target).hasClass("range-min")) {
                    rangeInput.eq(0).val(maxVal - priceGap);
                } else {
                    rangeInput.eq(1).val(minVal + priceGap);
                }
                console.log(maxVal);

            } else {
                priceInput.eq(0).val(minVal);
                priceInput.eq(1).val(maxVal);

                if(minVal != lastMin) {
                    clearTimeout($.data(this, 'priceTimer'));
                    $.data(this, 'priceTimer', setTimeout(() => priceInput.eq(0).trigger('change'), 500));
                }

                if(maxVal != lastMax) {
                    clearTimeout($.data(this, 'priceTimer'));
                    $.data(this, 'priceTimer', setTimeout(() => priceInput.eq(1).trigger('change'), 500));
                }
                range.css("left", ((minVal / rangeInput.eq(0).attr("max")) * 100) + "%");
                range.css("right", 100 - (maxVal / rangeInput.eq(1).attr("max")) * 100 + "%");
                lastMin = minVal;
                lastMax = maxVal;
            }
        });
    });

    // Toggle mobile nav dropdowns
    const navDropdowns = $('.navbar .dropdown > a');

    navDropdowns.each(function() {
        $(this).on('click', function(event) {
            if ($('.mobile-nav-active').length) {
                event.preventDefault();
                $(this).toggleClass('active');
                $(this).next().toggleClass('dropdown-active');

                let dropDownIndicator = $(this).find('.dropdown-indicator');
                dropDownIndicator.toggleClass('bi-chevron-up bi-chevron-down');
            }
        });
    });
});
